// src/pages/Home.jsx
import { motion } from "framer-motion";
import ProgramsSection from "../components/ProgramsSection";
import React from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";

function ServicesGalleryModal({ open, onClose, items = [], title = "" }) {



  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (!open) return;
    setIndex(0);
  }, [open, title]);

  React.useEffect(() => {
    function onKeyDown(e) {
      if (!open) return;
      if (e.key === "Escape") onClose?.();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    }
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, items, index]);

  function next() {
    if (!items.length) return;
    setIndex((i) => (i + 1) % items.length);
  }

  function prev() {
    if (!items.length) return;
    setIndex((i) => (i - 1 + items.length) % items.length);
  }

  if (!open) return null;
  const current = items[index];

return (

    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-5xl rounded-2xl bg-white overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200">
          <div className="font-extrabold text-gray-900 text-sm sm:text-base">
            {title || current?.alt || "Φωτογραφία"}
          </div>
          <button
            type="button"
            className="rounded-xl px-3 py-2 text-gray-700 hover:bg-gray-100 transition"
            onClick={onClose}
          >
            Κλείσιμο
          </button>
        </div>

        <div className="relative bg-black">
          <img
            src={current?.src}
            alt={current?.alt}
            className="w-full max-h-[78vh] object-contain bg-black"
          />

          <button
            type="button"
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 rounded-2xl bg-white/90 px-3 py-2 font-semibold text-gray-900 hover:bg-white transition"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-2xl bg-white/90 px-3 py-2 font-semibold text-gray-900 hover:bg-white transition"
          >
            ›
          </button>
        </div>

        <div className="px-4 sm:px-6 py-4 border-t border-gray-200">
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span>
              {items.length ? index + 1 : 0} / {items.length}
            </span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={prev}
                className="rounded-xl border border-gray-200 bg-white px-3 py-2 hover:bg-gray-50 transition"
              >
                Προηγ.
              </button>
              <button
                type="button"
                onClick={next}
                className="rounded-xl border border-gray-200 bg-white px-3 py-2 hover:bg-gray-50 transition"
              >
                Επόμ.
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
);
}

function ServicesGalleryTwoCards() {
  const gallery = {
    title: "Ενοικίαση Αιθουσών & Υποδομών",
    items: [
      { src: "/classrooms/sign1.jpg", alt: "Αίθουσα 1" },
      { src: "/classrooms/tech1.jpg", alt: "Αίθουσα 2" },
      { src: "/classrooms/theory1.jpg", alt: "Αίθουσα 3" },
    ],
  };

const [open, setOpen] = React.useState(false);

  return (
    <>
      <Seo
        title="ΚΔΒΜ2 ΘΗΣΕΑΣ – Προγράμματα Κατάρτισης & Voucher ΔΥΠΑ"
        description="Εκπαιδευτικά προγράμματα κατάρτισης, voucher ΔΥΠΑ, πιστοποιήσεις και επαγγελματική εκπαίδευση από το ΚΔΒΜ2 ΘΗΣΕΑΣ."
        keywords="ΚΔΒΜ2 ΘΗΣΕΑΣ, voucher ΔΥΠΑ, κατάρτιση, σεμινάρια, πιστοποιήσεις"
        url="https://theseus.edu.gr/"
        image="/theseus.png"
      />
	  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* LEFT: Rental + thumbnails */}
        <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8">
          <h3 className="text-xl font-extrabold text-gray-900">Ενοικίαση Αιθουσών & Υποδομών</h3>

          <p className="mt-4 text-gray-700 leading-relaxed">
            Το κέντρο διαθέτει αίθουσες σεμιναρίων και μαθημάτων δυναμικότητας έως 25 ατόμων, καθώς και μικρότερες αίθουσες,
            πλήρως εξοπλισμένες για εκπαίδευση και διδασκαλία.
          </p>

          <p className="mt-3 text-gray-700 leading-relaxed">
            Ο χώρος είναι προσβάσιμος σε Α.Μ.Ε.Α. και διαθέτει κατάλληλους χώρους υγιεινής.
          </p>

          <p className="mt-3 text-gray-700 leading-relaxed">
            Η αίθουσα πληροφορικής είναι εξοπλισμένη με σύγχρονους Η/Υ τελευταίας γενιάς με πρόσβαση στο διαδίκτυο.
          </p>

          <p className="mt-3 text-gray-700 leading-relaxed">
            Οι αίθουσες μπορούν να παραχωρηθούν σε φορείς και ιδιώτες για την υλοποίηση εκπαιδευτικών δράσεων.
          </p>

          {/* Thumbnails */}
          <div className="mt-6">
            <div className="text-sm font-semibold text-gray-800 mb-3">Φωτογραφίες Αιθουσών</div>

            <div className="grid grid-cols-3 gap-3">
              {gallery.items.map((it, idx) => (
                <button
                  key={it.src}
                  type="button"
                  className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition"
                  onClick={() => setOpen(true)}
                  aria-label={`Άνοιγμα φωτογραφίας ${idx + 1}`}
                >
                  <img
                    src={it.src}
                    alt={it.alt}
                    className="w-full aspect-[4/3] object-cover group-hover:scale-[1.03] transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition" />
                </button>
              ))}
            </div>

            <div className="mt-3 text-xs text-gray-500">
              Πατήστε σε οποιαδήποτε μικρογραφία για προβολή και περιήγηση.
            </div>
          </div>
        </div>

        {/* RIGHT: Activities (moved here) */}
        <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8">
          <h3 className="text-xl font-extrabold text-gray-900">Δραστηριότητες ΘΗΣΕΑΣ</h3>

          <ul className="mt-5 list-disc pl-6 space-y-3 text-gray-700 leading-relaxed">
            <li>Σχεδιασμός και υλοποίηση προγραμμάτων συνεχιζόμενης επαγγελματικής κατάρτισης.</li>
            <li>Οργάνωση εκπαιδευτικών και επιμορφωτικών σεμιναρίων, ημερίδων και συνεδρίων.</li>
            <li>Διασύνδεση καταρτιζομένων με την αγορά εργασίας και προώθησή τους στην απασχόληση μέσω πρακτικής άσκησης και επαγγελματικής εμπειρίας.</li>
            <li>Παροχή συμβουλευτικών υπηρεσιών σε ανέργους, εργαζόμενους, επιχειρήσεις, ιδρύματα, φορείς και συλλόγους.</li>
            <li>Εκπαίδευση εκπαιδευτών (training of trainers).</li>
            <li>Διοργάνωση βραχυχρόνιων, μακροχρόνιων ή μόνιμων κύκλων μαθημάτων για άτομα, ομάδες, γονείς, εταιρείες και φορείς.</li>
          </ul>
        </div>
      </div>

      <ServicesGalleryModal
        open={open}
        onClose={() => setOpen(false)}
        title={gallery.title}
        items={gallery.items}
      />
    </>
  );
}

function GlassButton({ text, onClick, href = "/#programs" }) {
  return (
    <a
      href={href}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault(); 
          onClick();          
        }
      }}
      className="
        group relative overflow-hidden
        inline-flex items-center justify-center text-center
        w-[260px] h-[58px]
        rounded-full
        font-extrabold tracking-wide text-base sm:text-[17px]
        text-black
        bg-gradient-to-b from-[#f7f7f7] via-[#dedede] to-[#bcbcbc]
        border border-[#2a2a2a]
        shadow-[0_8px_16px_rgba(0,0,0,0.18)]
        transition-all duration-200 ease-out
        hover:-translate-y-[2px]
        hover:shadow-[0_12px_22px_rgba(0,0,0,0.22)]
        active:translate-y-[1px]
        select-none
      "
    >
      {/* Inner chrome edge */}
      <span className="pointer-events-none absolute inset-[2px] rounded-full border border-white/70 opacity-90" />

      {/* Glass top highlight */}
      <span className="pointer-events-none absolute left-2 right-2 top-1 h-[45%] rounded-full bg-gradient-to-b from-white/90 to-transparent opacity-80" />

      {/* Inner depth */}
      <span className="pointer-events-none absolute inset-0 rounded-full shadow-[inset_0_-14px_18px_rgba(0,0,0,0.18)]" />

      {/* Hover glow (subtle blue rim) */}
      <span className="pointer-events-none absolute inset-0 rounded-full ring-0 group-hover:ring-2 group-hover:ring-primary-500/20 transition duration-200" />

      {/* Hover shine sweep */}
      <span
        className="
          pointer-events-none absolute
          -left-28 top-1 h-12 w-48
          rotate-[-18deg]
          bg-white/40 blur-md
          opacity-0
          group-hover:opacity-100
          group-hover:left-[110%]
          transition-all duration-500
        "
      />

      <span className="relative z-10">{text}</span>
    </a>
  );
}

function Home() {
	  const navigate = useNavigate();
  return (

    <div id="top" className="space-y-16">
{/* ================= HERO SECTION ================= */}
<section className="relative min-h-[720px] sm:min-h-[780px] lg:min-h-[820px] flex items-center justify-center px-4 py-12 overflow-hidden">
{/* ===== BACKGROUND (bg1.jpg from /public) ===== */}
<div className="absolute inset-0 overflow-hidden">
<img
  src={`${process.env.PUBLIC_URL}/bg1.jpg`}
  alt=""
  className="absolute inset-0 w-full h-full object-cover object-center"
/>

  {/* Overlay ώστε να μην “καίει” η φωτο και να δένει με το panel */}
  <div className="absolute inset-0 bg-gradient-to-b from-white/75 via-white/55 to-black/15" />

  
  
</div>

  {/* ===== CONTENT ===== */}
  <div className="relative w-full max-w-5xl mx-auto text-center flex flex-col items-center">

    {/* Panel */}
    <div
      className="
        relative w-full max-w-4xl
        rounded-3xl
        border border-black/5
        bg-white/80
        backdrop-blur-md
        px-6 py-9 sm:px-8 sm:py-11
        shadow-[0_20px_50px_rgba(0,0,0,0.18)]
      "
    >

      {/* Title */}
      <motion.h1
        className="
          text-[clamp(1.6rem,4.8vw,2.4rem)]
          sm:text-4xl lg:text-5xl
          font-extrabold leading-snug tracking-tight
          text-primary-800
        "
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="block sm:inline">Προγράμματα</span>{" "}
        <span className="block sm:inline">Voucher &</span>{" "}
        <span className="block sm:inline">Αυτοχρηματοδοτούμενα</span>
      </motion.h1>

      {/* Subtitle */}
      <motion.p
        className="
          mt-4
          text-lg sm:text-xl lg:text-2xl
          leading-relaxed
          text-gray-800
          max-w-3xl mx-auto
        "
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        Δείτε διαθέσιμα προγράμματα κατάρτισης και επανακατάρτισης για ανέργους
        και εργαζόμενους, με ξεκάθαρη ένδειξη κατάστασης.
      </motion.p>

      {/* Buttons */}
      <motion.div
        className="mt-8 max-w-3xl mx-auto"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
          <GlassButton
		  text="Voucher"
		  onClick={() => {
			window.dispatchEvent(
			  new CustomEvent("programs:setFilters", {
				detail: { typeFilter: "voucher", voucherAudienceFilter: "unemployed", statusFilter: "all" },
			  })
			);
			document.getElementById("programs")?.scrollIntoView({ behavior: "smooth" });
		  }}
		/>

		<GlassButton
		  text="Αυτοχρηματοδοτούμενα"
		  onClick={() => {
			window.dispatchEvent(
			  new CustomEvent("programs:setFilters", {
				detail: { typeFilter: "selfFunded", voucherAudienceFilter: "unemployed", statusFilter: "all" },
			  })
			);
			document.getElementById("programs")?.scrollIntoView({ behavior: "smooth" });
		  }}
		/>

          <GlassButton text="Άλλα επιδοτούμενα" />
        </div>

        <div className="mt-4 flex justify-center gap-4 flex-wrap">
          <GlassButton
  text="Άδεια Χειριστή ΚΛΑΡΚ"
  onClick={() => navigate("/clark")}
/>

<GlassButton
  text="Άδεια Security (ΙΕΠΥΑ)"
  onClick={() => navigate("/security")}
/>
        </div>
      </motion.div>
{/* Info strip */}
<div className="mt-6 w-full max-w-3xl mx-auto">
  <div className="rounded-2xl border border-black/10 bg-white/70 backdrop-blur-md px-5 py-4 shadow-[0_12px_26px_rgba(0,0,0,0.12)]">
    <p className="text-center text-base sm:text-lg text-gray-700 font-medium leading-relaxed">
      Επικοινωνήστε μαζί μας για πληροφορίες και υποστήριξη στη διαδικασία εγγραφής.
    </p>

    <div className="mt-3 flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-6">
      <a
        href="tel:+30251060020507"
        className="font-semibold text-gray-900 hover:text-primary-800 transition"
      >
        2510 600 205-07
      </a>

      <span className="hidden sm:inline text-gray-300">•</span>

      <a
        href="/contact"
        className="font-semibold text-gray-900 hover:text-primary-800 transition"
      >
        info@theseus.edu.gr
      </a>
    </div>
  </div>
</div>
    </div>
  </div>
</section>


      {/* Programs list/cards/table */}
      <ProgramsSection />

      {/* Help & Contact CTA (ultra-tight spacing) */}
      <section className="py-2 bg-white">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <div className="rounded-3xl border border-gray-200 bg-gray-50 px-6 py-8 sm:px-10 shadow-sm">
            <h3 className="text-2xl sm:text-3xl font-extrabold text-gray-900">
              Χρειάζεστε βοήθεια;
            </h3>

            <p className="mt-3 text-gray-600 text-lg sm:text-xl max-w-xl mx-auto">
              Επικοινωνήστε μαζί μας για πληροφορίες σχετικά με τα προγράμματα και
              υποστήριξη στη διαδικασία εγγραφής.
            </p>

            <div className="mt-6 flex justify-center">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-2xl bg-gray-900 px-8 py-4 text-white font-semibold text-base sm:text-lg hover:bg-black transition shadow-lg"
              >
                Φόρμα Επικοινωνίας
              </a>
            </div>
          </div>
        </div>
      </section>

 {/* Other Actions & Services */}
<section id="services" className="bg-white py-14">
  <div className="container mx-auto px-4">
    <div className="text-center mb-12">
      <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">Άλλες Δράσεις & Υπηρεσίες</h2>
      <p className="mt-3 text-gray-600 max-w-3xl mx-auto">
        Υποστηρίζουμε επαγγελματίες, εργαζόμενους, ανέργους και φορείς με εξειδικευμένες εκπαιδευτικές υπηρεσίες και σύγχρονες υποδομές.
      </p>
    </div>

    <ServicesGalleryTwoCards />
  </div>
</section>

    </div>
  );
}

export default Home;
